// @unocss-include
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogClose, DialogContent, DialogTitle, P, } from '@a-type/ui';
import { useEffect, useState } from 'react';
import { useIsLoggedIn } from '../hooks/graphql.js';
import { useWasLoggedIn } from '../hooks/useWasLoggedIn.js';
import { LoginButton } from './LoginButton.js';
export function LogoutNotice({}) {
    const [wasLoggedIn, setWasLoggedIn] = useWasLoggedIn();
    const [isLoggedIn, loadingLoggedInStatus] = useIsLoggedIn();
    const [close, setClose] = useState(false);
    const isLoginPage = window.location.pathname === '/login' ||
        window.location.pathname === '/verify';
    const wasLoggedInButNowLoggedOut = !close && wasLoggedIn && !isLoggedIn && !loadingLoggedInStatus;
    // only want to fire this when session changes, not when flag changes.
    // flag can be reset manually.
    useEffect(() => {
        if (isLoggedIn) {
            setWasLoggedIn(true);
        }
    }, [isLoggedIn, setWasLoggedIn]);
    if (isLoginPage)
        return null;
    return (_jsx(Dialog, { open: wasLoggedInButNowLoggedOut, onOpenChange: setWasLoggedIn, children: _jsxs(DialogContent, { children: [_jsx(DialogTitle, { children: "Session expired" }), _jsx(P, { children: "To resume syncing your data, please sign in again." }), _jsxs("div", { className: "flex flex-row gap-3 justify-end items-center", children: [_jsx(DialogClose, { asChild: true, children: _jsx(Button, { color: "ghost", children: "Cancel" }) }), _jsx(DialogClose, { asChild: true, children: _jsx(LoginButton, { color: "primary", onClick: () => setClose(true), children: "Sign in" }) })] })] }) }));
}
//# sourceMappingURL=LogoutNotice.js.map